import { atom } from 'jotai';

enum PageStatusEnum {
  locateCodeInput = "locateCodeInput",
  locateCodeSubmitLoading = "locateCodeSubmitLoading",
  shareLocation = "shareLocation",
  userLocationDenied = "userLocationDenied",
  locateCodeAndLocationLoading = "locateCodeAndLocationLoading",
  error = "error",
  locateUnauthorized = "locateUnauthorized",
  locateAuthorized = "locateAuthorized",
}

interface LocateState {
  devLocateCode: string | null; // for dev/testing only
  locateCode: string | null; // will get populated when we know it's legit
  locateCodeError: string | null; // will get populated if there is an issue with the locateCode
  lat: number | null; // will get populated when user shares location
  long: number | null; // will get populated when user shares location
  verifiedStationShortCommonName?: string | null; // will get populated when we verify the code + lat/long
  pageStatus: PageStatusEnum;
};

const defaultLocateState: LocateState = {
  devLocateCode: null,
  locateCode: null,
  locateCodeError: null,
  lat: null,
  long: null,
  pageStatus: PageStatusEnum.locateCodeInput,
  verifiedStationShortCommonName: null,
};

const locateAtom = atom<LocateState>(defaultLocateState);

export { PageStatusEnum, locateAtom, defaultLocateState };
